<script setup>
import { useI18n } from 'vue-i18n';
import LaisCard from 'dashboard/components-next/LaisCard.vue';

defineProps({
  money: { type: Function, required: true },
  plan: { type: Object, required: true },
});

const { t } = useI18n();
</script>

<template>
  <LaisCard
    :title="t('REAL_ESTATE_COMMISSION_PLAN.SUMMARY.SALE')"
    prefix-icon="i-lucide-house"
  >
    <div class="mt-5 grid gap-4 sm:grid-cols-3">
      <div>
        <p class="text-xs text-lais-text-muted">
          {{ t('REAL_ESTATE_COMMISSION_PLAN.FIELDS.GROSS') }}
        </p>
        <p class="mt-1 font-semibold text-lais-text">
          {{ money(plan.valor_comissao_total) }}
        </p>
      </div>
      <div>
        <p class="text-xs text-lais-text-muted">
          {{ t('REAL_ESTATE_COMMISSION_PLAN.FIELDS.DEDUCTION') }}
        </p>
        <p class="mt-1 font-semibold text-lais-text">
          {{ money(plan.deducao) }}
        </p>
      </div>
      <div>
        <p class="text-xs text-lais-text-muted">
          {{ t('REAL_ESTATE_COMMISSION_PLAN.FIELDS.NET') }}
        </p>
        <p class="mt-1 font-semibold text-lais-primary">
          {{ money(plan.valor_comissao_liquida) }}
        </p>
      </div>
    </div>
  </LaisCard>
</template>
